// import TableSaveRow from './.TableSaveRow/TableSaveRow.Node'
import { warn } from "@swivl-mono/helpers";
import { FMSType, NodeType } from "@swivl-mono/types";

import Action from "./Action";
import Analytics from "./Analytics.Node";
import ArrayNode from "./Array/Array.Node";
import ArrayPickerNode from "./ArrayPicker/ArrayPicker.Node";
import Buttons from "./Buttons.Node";
import Carousel from "./Carousel.Node";
import Command from "./Command.Node";
import Continue from "./Continue.Node";
// import CRM from './CRM'
import DateAndTime from "./DateAndTime.Node";
import Email from "./Email.Node";
import Escalation from "./Escalation.Node";
// import Experiment from './Experiment'
// import ExperimentEnd from './ExperimentEnd'
import Finish from "./Finish.Node";
// import Hubspot from './.Hubspot'
import IncrementNode from "./Increment/Increment.Node";
import InputNode from "./Input.Node";
import LLMNode from "./LLM/LLM.Node";
import LeasePickerNode from "./LeasePicker/LeasePicker.Node";
import Logic from "./Logic.Node";
import Media from "./Media.Node";
import Message from "./Message.Node";
import MultiSelect from "./MultiSelect.Node";
// import Nlp from './NLP'
// import Notification from './Notification'
import OpenOrClose from "./OpenOrClose.Node";
// import PastMessages from './PastMessages'
import ProfileCollect from "./ProfileCollect.Node";
import Quest from "./Quest.Node";
import Random from "./Random.Node";
// import Route from './Route'
import RouterStart from "./RouterStart.Node";
// import Slack from './.Slack'
import SMS from "./SMS.Node";
import SMSGroup from "./SMSGroup/SMSGroup.Node";
import Save from "./Save/Save.Node";
import SpacePicker from "./SpacePicker.Node";
import Start from "./Start.Node";
import StoreAccessCodes from "./StoreAccessCodes.Node";
import StoreFinderLookup from "./StoreFinderLookup/StoreFinderLookup.Node";
import StoreGetTenant from "./StoreGetTenant.Node";
import StoreInfo from "./StoreInfo.Node";
import StoreLead from "./StoreLead.Node";
import TableSaveRow from "./TableSaveRow/TableSaveRow.Node";
import TypingIndicator from "./TypingIndicator.Node";
import URLNode from "./URL.Node";
import VoiceNode from "./Voice/Voice.Node";
import UserValidationNode from "./UserValidation/UserValidation.Node";
import ShortURLNode from "./ShortURL/ShortURL.Node";
import MergeUserNode from "./Merge/MergeUser.Node";
import ValidateNormalizeNode from "./ValidateNormalize/ValidateNormalize.Node";
import PaymentLinkNode from "./PaymentLink.Node";
import NoteNode from "./Note/Note.Node";
import LoadData from "./LoadData/LoadData.Node";


const NodeModel = {
  forType(type: NodeType) {
    switch (type) {
      case ArrayNode.Type:
        return ArrayNode;
      case NodeType.ArrayPicker:
        return ArrayPickerNode;
      case Action.Type:
        return Action;
      case Analytics.Type:
        return Analytics;
      case Buttons.Type:
        return Buttons;
      case Carousel.Type:
        return Carousel;
      case Command.Type:
        return Command;
      case Continue.Type:
        return Continue;
      // case CRM.Type:                  return CRM;
      case DateAndTime.Type:
        return DateAndTime;
      case Email.Type:
        return Email;
      case Escalation.Type:
        return Escalation;
      // case Experiment.Type:           return Experiment;
      // case ExperimentEnd.Type:        return ExperimentEnd;
      case Finish.Type:
        return Finish;
      // case Hubspot.Type:              return Hubspot;
      case IncrementNode.Type:
        return IncrementNode;
      case InputNode.Type:
        return InputNode;
      case NodeType.LeasePicker:
        return LeasePickerNode;
      case Logic.Type:
        return Logic;
      case LLMNode.Type:
        return LLMNode;
      case NodeType.LoadData:
        return LoadData;
      case Media.Type:
        return Media;
      case NodeType.MergeUser:
        return MergeUserNode;
      case Message.Type:
        return Message;
      case MultiSelect.Type:
        return MultiSelect;
      // case Nlp.Type:                  return Nlp;
      // case Notification.Type:         return Notification;
      case NodeType.Note:
        return NoteNode;
      case OpenOrClose.Type:
        return OpenOrClose;
      // case PastMessages.Type:         return PastMessages;
      case ProfileCollect.Type:
        return ProfileCollect;
      case Quest.Type:
        return Quest;
      case Random.Type:
        return Random;
      // case Route.Type:                return Route;
      case RouterStart.Type:
        return RouterStart;
      case Save.Type:
        return Save;
      // case Slack.Type:                return Slack;
      case SMS.Type:
        return SMS;
      case SMSGroup.Type:
        return SMSGroup;
      case SpacePicker.Type:
        return SpacePicker;
      case Start.Type:
        return Start;
      case StoreFinderLookup.Type:
        return StoreFinderLookup;
      case StoreGetTenant.Type:
        return StoreGetTenant;
      case StoreAccessCodes.Type:
        return StoreAccessCodes;
      case StoreInfo.Type:
        return StoreInfo;
      case StoreLead.Type:
        return StoreLead;
      case TableSaveRow.Type:
        return TableSaveRow;
      case TypingIndicator.Type:
        return TypingIndicator;
      case NodeType.UserValidation:
        return UserValidationNode; // Assuming UserValidationNode is defined elsewhere
      case URLNode.Type:
        return URLNode;
      case NodeType.ValidateNormalize:
        return ValidateNormalizeNode;
      case NodeType.ShortURL:
        return ShortURLNode;
      case VoiceNode.Type:
        return VoiceNode;
      case PaymentLinkNode.Type:
        return PaymentLinkNode;
      // You can add a default case if needed
      default:
        // Handle unknown type


        break;
    }

    warn("No Node For Type", type);
    return null;
  },
};
export default NodeModel;
